import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import { useIsWidthUp } from '../../theme';
import { Background, Maybe, Scalars } from '../../types';
import { useEventListener } from '../../utils/hooks';
import { useTextStyles } from '../../utils/styles';
import { IKImage } from '../IKImage';
import { useCardStyles } from './styles';


interface CardProps {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  background?: Maybe<Background>;
  wrapperClass?: string;
}

const Card: FC<CardProps> = ({ background, imageUrl, title, description, wrapperClass }) => {
  const [minTileHeight, setMinTileHeight] = useState(0);
  const [showBackTile, setShowBackTile] = useState(false);

  const backTileRef = useRef<HTMLDivElement>(null);

  const isMobile = !useIsWidthUp('md');
  const classes = useCardStyles(background, minTileHeight, description && !isMobile)();
  const textClasses = useTextStyles();

  const handleClickCard = () => {
    if (isMobile && description) {
      setShowBackTile((prevState) => !prevState);
    }
  };

  const handleResize = useCallback(() => {
    if (backTileRef.current?.offsetHeight) {
      setMinTileHeight(backTileRef.current.offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backTileRef.current]);

  useEventListener('resize', handleResize);

  useEffect(() => {
    handleResize();
  }, [handleResize]);

  return (
    <div
      className={cx(classes.wrapper, wrapperClass, isMobile && showBackTile && classes.toggled)}
      onClick={handleClickCard}
    >
      <div className={cx(classes.tile, classes.frontTile)}>
        <IKImage path={imageUrl} className={classes.bigImg} />
        {title && (
          <Typography variant="h3" align="center" className={textClasses.h3}>
            {title}
          </Typography>
        )}
      </div>
      {description && (
        <div className={cx(classes.tile, classes.backTile)}>
          <div ref={backTileRef} className={classes.backTileContent}>
            <IKImage path={imageUrl} className={classes.img} />
            <Typography className={textClasses.bodyText}>{description}</Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
